import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What programming languages are most important for a career in AI?",
    // category: "Technology",
    description:
      "Python is the most widely used AI language because of its simple syntax and powerful libraries like TensorFlow, PyTorch, NumPy, and Pandas. Although R, Java, and C++ appear in specific areas, Python remains the primary choice for AI development.",
  },
  {
    title: "What industries are currently using AI the most?",
    // category: "Trending",
    description:
      "AI is used across major industries like healthcare, finance, e-commerce, automotive, telecom, cybersecurity, and education. It helps automate processes, analyze data, detect fraud, enhance customer experience, and power smarter, more efficient digital products.",
  },
  {
    title: "What kind of projects will I work on in the AI domain?",
    // category: "Design",
    description:
      "AI projects focus on solving real-world problems using data and machine learning. Common examples include image classification, chatbots, sentiment analysis, recommendation systems, object detection, and fraud detection. These projects build practical experience and make you industry-ready.",
  },
  {
    title: "What are the challenges commonly faced in an AI career?",
    // category: "Design",
    description:
      "AI challenges include handling noisy or incomplete data, selecting suitable algorithms, understanding model behavior, managing hardware limits, and improving accuracy. These difficulties become easier to manage with consistent practice, guidance, and real-world project experience.",
  },
  {
    title:
      "What job roles are available in the field of Artificial Intelligence?",
    // category: "Design",
    description:
      "AI offers many career opportunities, including roles like AI Engineer, Machine Learning Engineer, Data Scientist, NLP Engineer, Computer Vision Engineer, and AI Researcher. Each role specializes in areas such as automation, language processing, image recognition, and model development.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
